import React, { useState, useEffect } from "react";
import Fade from "react-reveal/Fade";
import Heading from "common/components/Heading";
import BlogPost from "common/components/BlogPost";
import Container from "common/components/UI/Container";
import { SectionHeader } from "../global.style";
import SectionWrapper, { FeatureWrapper } from "./feature.style";

const Feature = () => {
  const [featuresData, setFeaturesData] = useState(null);

  useEffect(() => {
    // const apiUrl = process.env.GATSBY_API_URL;
    // console.log("Using API URL:", apiUrl); // Debugging
  
    fetch(`https://radianceadmin.manageprojects.in/api/product-features`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setFeaturesData(data.data[0]);
        }
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);
  
  if (!featuresData) return <div></div>;
  

  // Generate features array dynamically from API data
  const featureKeys = ['', 'one', 'two', 'three'];
  const allFeatures = featureKeys.map((key, index) => ({
    id: index + 1,
    icon: featuresData[`features_img${key}`],
    title: featuresData[`features_title${key}`],
    description: featuresData[`features_description${key}`],
  }));

  return (
    <SectionWrapper id="whyRadiance">
      <Container className="myContainer clasno bg-image">
        <div className="row">
          <div className="col-md-6" style={{ display: 'flex', alignItems: 'center' }}>
            <Fade bottom>
              <SectionHeader className="" style={{ textAlign: 'left' }}>
                <Heading as="h5" content={featuresData.sub_heading} />
                <div dangerouslySetInnerHTML={{ __html: featuresData.product_content }} />
              </SectionHeader>
            </Fade>
          </div>
          <div className="col-md-6">
            <Fade bottom delay={30}>
              <div className="parent">
                {allFeatures.map((item) => (
                  <BlogPost
                    key={`feature_key${item.id}`}
                    thumbUrl={item.icon}
                    title={item.title}
                    className={`div${item.id}`}
                    excerpt={item.description}
                  />
                ))}
              </div>
            </Fade>
          </div>
        </div>
      </Container>
    </SectionWrapper>
  );
};

export default Feature;